// extracted by mini-css-extract-plugin
export var container = "_2u-0";
export var icon = "_2u-1";